import type { MyAccounts } from '@repo/contracts';

import { apiFetch } from './client';

/** The switcher's data: the caller's personal accountId plus every team they
 *  can switch into. Read-only from the client's side — teams themselves are
 *  created/invited-to elsewhere (flotoapps), not here. */

export const tenantKeys = {
  all: ['tenant'] as const,
  accounts: () => [...tenantKeys.all, 'accounts'] as const,
};

export const listMyAccounts = () => apiFetch<MyAccounts>('/canvas/accounts');
